import { Component, HostListener, OnInit } from "@angular/core";

import { AuthService } from "../../../../services/auth.service";
import { Router } from "@angular/router";

import * as moment from "moment";
import { FillBatchReportService } from "../../../../services/fill-batch-report.service";
import { ModalService } from "../../../../services/modal.service";
import { FillPressure } from "../../../../models/fill_pressure";
import { SnotifyService } from "ng-snotify";
import { UploadService } from "../../../../services/upload.service";
import * as FileSaver from "file-saver";

@Component({
  selector: "app-upload-fill-batch",
  templateUrl: "./upload-fill-batch.component.html",
  styleUrls: ["./upload-fill-batch.component.css"],
})
export class UploadFillBatchComponent implements OnInit {
  modalService: ModalService;
  snotifyService: SnotifyService;
  uploadService: UploadService;

  pressureList: FillPressure[];

  filter: any = {
    expiry_Date: moment().add(3, "years").add(-1, "days").toDate(),
    fill_Date: moment().toDate(),
    fill_Pressure_Id: 0,
    batch_Num: "",
  };

  init: boolean;
  is_client = false;
  client;

  downloadLink: string | null = null;
  showDownloadButton: boolean = false;
  fileResult: string | null = null;

  base64: string;
  dropFileText = "Drop your excel file here or click to browse.";
  showDownloadIcon = false;
  showUploadedFileIcon = false;

  constructor(
    authService: AuthService,
    public fillBatchReportService: FillBatchReportService,
    public router: Router,
    modalService: ModalService,
    snotifyService: SnotifyService,
    uploadService: UploadService
  ) {
    this.is_client = authService.currentUser.value.userType == 0;
    this.client = authService.currentUser.value;
    this.modalService = modalService;
    this.snotifyService = snotifyService;
    this.uploadService = uploadService;

    this.fillBatchReportService.getFillPressures().then((fillPressures) => {
      this.pressureList = fillPressures;
      console.log(this.pressureList);
    });
  }
  
  ngOnInit() {
    this.init = true;
    this.onFillDateChange();
    console.log(this.client);

  }

  @HostListener("dragenter", ["$event"]) onDragEnter(event: DragEvent) {
    this.preventAndStop(event);
    //console.log('Dragging entered the drop zone');
  }

  @HostListener("dragover", ["$event"]) onDragOver(event: DragEvent) {
    this.preventAndStop(event);
    //console.log('Dragging over the drop zone');
  }

  @HostListener("dragleave", ["$event"]) onDragLeave(event: DragEvent) {
    this.preventAndStop(event);
    //console.log('Dragging left the drop zone');
  }

  @HostListener("drop", ["$event"]) onDrop(event: DragEvent) {
    this.preventAndStop(event);

    const files = event.dataTransfer.files;
    if (files) {
      //console.log("Dropped Files: ", files)
      this.onFileDropped(event);
    }
  }

  private preventAndStop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const file = inputElement.files[0];

    inputElement.value = "";

    this.showDownloadButton = false;
    this.fileResult = null;

    if (file) {
      this.convertToBase64(file);
    }
  }

  onFileDropped(e: DragEvent) {
    let file = e.dataTransfer.files[0];
    if (file) {
      this.base64 = null;
      this.convertToBase64(file);
    }
  }

  convertToBase64(file: any): void {
    var rawBase64 = null;
    var base64 = null;

    // If a file was selected
    if (file) {
      if (!file.name.includes(".xlsx")) {
        this.snotifyService.error(
          "Invalid format, please select an Excel file (.xlsx).",
          { timeout: 5000 }
        );
        console.log("Invalid Format");
        this.showDownloadIcon = false;
        return;
      }

      var reader = new FileReader();
      reader.readAsDataURL(file);

      // Split the initial data type string from the base64 data
      reader.onload = (e) => {
        rawBase64 = reader.result;
        base64 = rawBase64.split(",", 2);
        this.base64 = base64[1];
      };

      reader.onerror = function (error) {
        console.log("Error: ", error);
      };

      this.dropFileText = file.name;
      this.showUploadedFileIcon = true;
      this.showDownloadIcon = false;
    }
  }
  
  upload(): void {
    if (this.filter.batch_Num == "") {
      this.snotifyService.error("Please input a batch number.", {
        timeout: 5000,
      });
      return;
    }

    if (this.filter.fill_Pressure_Id == 0) {
      this.snotifyService.error("Please select a pressure.", { timeout: 5000 });
      return;
    }
    
    if (this.base64 != null) {
      this.uploadService
        .uploadFillBatch(
          this.base64,
          this.client.firstname,
          this.client.lastname,
          this.filter.batch_Num,
          this.filter.fill_Pressure_Id,
          moment(this.filter.fill_Date).format("YYYY-MM-DD"),
          moment(this.filter.expiry_Date).format("YYYY-MM-DD")
        )
        .then((data) => {
          this.removeUpload();
          console.log(data);

          if (data.success == true && data.fileResult) {
            this.snotifyService.success(data.message, { timeout: 3000 });
            this.fileResult = data.fileResult;
            this.showDownloadButton = true;
            this.filter.fill_Pressure_Id = 0;
            this.filter.batch_Num = "";
            this.filter.expiry_Date = moment().add(3, "years").add(-1, "days").toDate();
            this.filter.fill_Date = moment().toDate();
          } else if (!data.fileResult) {
            this.snotifyService.error("No file was generated for download.", {
              timeout: 5000,
            });
            this.showDownloadButton = false;
          } else {
            this.fileResult = data.fileResult;
            this.showDownloadButton = true;
            this.snotifyService.error(
              "Error uploading batches: " + data.message,
              { timeout: 5000 }
            );
          }
        })
        .catch((err) => {
          this.removeUpload();
          this.snotifyService.error("Error, unable to upload batches.", {
            timeout: 3000,
          });
        });
    } else {
      this.snotifyService.error("Please upload an excel file.", {
        timeout: 5000,
      });
    }
  }

  removeUpload() {
    this.dropFileText = "Drop your excel file here or click to browse.";
    this.showUploadedFileIcon = false;
    this.base64 = null;
    this.showDownloadButton = false;
    this.fileResult = null;
  }

  onUploadDragOver() {
    this.showDownloadIcon = true;
  }

  onUploadDragLeave() {
    this.showDownloadIcon = false;
  }

  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById("top");
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  createDownloadLink(base64: string, fileName: string) {
    if (!base64) {
      this.snotifyService.error("No file available for download.", {
        timeout: 5000,
      });
      return;
    }
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    FileSaver.saveAs(blob, fileName);
  }

  onFillDateChange() {
    this.filter.expiry_Date = moment(this.filter.fill_Date)
      .add(3, 'years')
      .subtract(1, 'day')
      .toDate();
  }
}
